@for (letter of letters(); track $index) {
  <!-- The letters hop one after another while partying -->
  <span
    class="inline-block [animation-delay:calc(var(--i)*0.12s)] motion-reduce:animate-none"
    aria-hidden="true"
    [class.anim-hop]="isPartying()"
    [style.--i]="$index"
  >
    <span
      class="inline-block bg-linear-to-b from-[#fffbe0] via-[#ffd24d] via-45% to-[#f08a1c] bg-clip-text text-transparent transition-[filter] duration-900 [--glow-color:rgb(255_190_70/0.9)] [-webkit-text-stroke:0.035em_#fff3b0] motion-reduce:animate-none"
      [class]="glowClass()"
      >{{ letter }}</span
    >
  </span>
}
